import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    auto: { type: Boolean, default: false },
    timeout: { type: Number, default: 4000 }
  }

  connect() {
    if (!this.autoValue) return

    this.dismissTimeout = setTimeout(() => {
      this.dismiss()
    }, this.timeoutValue)
  }

  dismiss() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
      this.dismissTimeout = null
    }

    this.element.remove()
  }

  disconnect() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
      this.dismissTimeout = null
    }
  }
}
